// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"UsedCars_bodyWrapper__2a7bF","bodyWrapperBlur":"UsedCars_bodyWrapperBlur__BRRHq"};